import { map, Observable } from 'rxjs';
import { filterRouteActive } from 'router/declarative/filterRouteActive';
import { AppLocation, location$ } from 'router/declarative/location$';
import { ReportModule } from '../types';
import { ReportModuleRoute } from './types';

export const REPORT_ROUTE = '/report';

const toReportModuleRoute = (
  location: AppLocation<typeof REPORT_ROUTE>
): ReportModuleRoute => {
  switch (location.route) {
    case '/report/builder':
      return {
        reportModule: ReportModule.BUILDER,
        reportId: undefined,
        filters: undefined,
        stateId: undefined,
      };
    case '/report/builder/:reportId':
      return {
        reportModule: ReportModule.BUILDER,
        reportId: location.params.reportId,
        filters: undefined,
        stateId: undefined,
      };
    case '/report/reader/:reportId':
      return {
        reportModule: ReportModule.READER,
        reportId: location.params.reportId,
        filters: location.searchParams?.filters,
        stateId: location.searchParams?.state,
      };
    default:
      return {
        reportModule: ReportModule.OVERVIEW,
        reportId: undefined,
        filters: undefined,
        stateId: undefined,
      };
  }
};

export const reportRouteNavigation$: Observable<ReportModuleRoute> =
  location$.pipe(filterRouteActive(REPORT_ROUTE), map(toReportModuleRoute));
